import {
  submitStatus,
  submitStatusSuccess,
  submitStatusFailure,
  submitStatusFailureDismiss,
} from '../actions';

export default {
  [submitStatus.toString()]: state => ({
    ...state,
    statusEdit: {
      ...state.statusEdit,
      isSubmitting: true,
      error: undefined,
    },
  }),
  [submitStatusSuccess.toString()]: (state, action) => ({
    ...state,
    statusEdit: {
      ...state.statusEdit,
      isSubmitting: true,
      statusId: action.payload.statusId,
      error: undefined,
    },
  }),
  [submitStatusFailure.toString()]: (state, action) => ({
    ...state,
    statusEdit: {
      ...state.statusEdit,
      isSubmitting: false,
      error: action.payload.error,
    },
  }),
  [submitStatusFailureDismiss.toString()]: state => ({
    ...state,
    statusEdit: {
      ...state.statusEdit,
      error: undefined,
    },
  }),
};
